import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Header
    nav: {
      about: 'About Us',
      services: 'Our Services',
      contact: 'Contact Us',
    },
    // Hero
    hero: {
      badge: 'Munich • Amman',
      title: 'Connecting Global Standards with Regional Excellence',
      subtitle: 'AIM TRADE is a strategic product management and paper trading firm. We bridge the gap between global sourcing and reliable execution across the Middle East, delivering quality you can trust through our offices in Munich and Amman.',
      ctaPrimary: 'Request Technical Specifications',
      ctaSecondary: 'Become a Distributor',
      countriesServed: 'Countries Served',
      regionalPartners: 'Regional Partners',
    },
    // About
    about: {
      title: 'About Us',
      whoWeAre: 'Who We Are',
      whoWeAreText: 'Founded by Ahmad Ismail Mousa, AIM TRADE operates as a dual-hub enterprise with strategic bases in Germany and Jordan. We specialize in managing the full value chain — from sourcing with premier international manufacturers to ensuring seamless regional delivery.',
      mission: 'Our Mission',
      missionText: 'To empower our partners\' success by delivering world-class products through a transparent, high-efficiency network that makes global sourcing feel local and effortless.',
      vision: 'Our Vision',
      visionText: 'To be the most trusted gateway for premium global brands in the Middle East, enriching regional markets by ensuring every partner and consumer has access to international quality without compromise.',
      coreValues: 'Our Core Value',
      coreValueText: 'Our business is built on operational discipline and deep market intelligence. We don\'t just supply products; we manage long-term market growth through strong relationships and a commitment to consistent reliability.',
      // Why AIM TRADE
      whyTitle: 'Why AIM TRADE?',
      why1Title: 'Regional & Global Footprint',
      why1Text: 'Operating through strategic hubs in Munich and Amman, allowing us to bridge the gap between global manufacturers and local markets seamlessly.',
      why2Title: 'End-to-End Supply Chain',
      why2Text: 'We manage the entire value chain, from Factory to Shelf. We ensure sourcing quality, logistics, and final placement meet the highest standards.',
      why3Title: 'Market Intelligence',
      why3Text: 'Deep expertise and analytical insights into Middle Eastern markets, enabling us to identify opportunities and ensure brand success in competitive environments.',
    },
    // Services
    services: {
      title: 'Our Specialized Services',
      subtitle: 'Delivering excellence through strategic partnerships and operational expertise',
      tab1: 'Paper Trading & Supply Chain',
      tab2: 'Brand Management & Agency Services',
      tab3: 'Business Development & Market Entry',
      partners: 'Partners:',
      // Paper Trading
      paperTitle: 'Paper Trading & Supply Chain',
      paperQuote: '"Precision in Sourcing, Reliability in Delivery."',
      paperText: 'We provide comprehensive paper solutions for international and regional industrial leaders. By managing everything from global procurement to final logistics, we ensure our partners receive materials that meet rigorous industry standards on time, every time.',
      // Brand Management
      brandTitle: 'Brand Management & Agency Services',
      brandQuote: '"Building Premium Brands, Expanding Regional Horizons."',
      brandText: 'Through our agency arm, we hold the representation and development rights for premium international brands across the Middle East. We act as the Principal Regional Partner, managing and appointing exclusive local distributors in each market to ensure brand consistency and controlled expansion.',
      managedBrands: 'Managed Brands:',
      distributionPartners: 'Regional Distribution Network:',
      // Business Development
      businessTitle: 'Business Development & Market Entry',
      businessQuote: '"Your Strategic Gateway to Cross-Border Growth."',
      businessText: 'We leverage our dual presence in Europe and the Middle East to identify high-growth opportunities. This sector focuses on helping companies navigate regional markets through tailored solutions, strategic consulting, and partnership-driven expansion.',
      businessPartnerName: 'Al-Ameer Printing Company',
      businessPartnerDesc: 'Supporting strategic production, execution, and market expansion across the region',
      ourApproach: 'Our Approach:',
      approach1Title: 'Strategic Consulting',
      approach1Text: 'Tailored market entry strategies',
      approach2Title: 'Partnership-Driven',
      approach2Text: 'Building long-term relationships',
      approach3Title: 'Dual Presence',
      approach3Text: 'Europe & Middle East expertise',
    },
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'Connect with our teams in Munich and Amman',
      regionalOffice: 'Regional Head Office – Amman',
      internationalOffice: 'International Office – Munich',
      address: 'Address',
      email: 'Email',
      phone: 'Phone',
      ammanLocation: 'Amman, Jordan',
      munichLocation: 'Munich, Germany',
      ctaTitle: 'Ready to Partner With Us?',
      ctaText: 'Reach out to discuss how we can support your business goals with premium products and reliable execution',
      ctaEmail: 'Send Us an Email',
      ctaPhone: 'Call Us',
    },
    // Footer
    footer: {
      description: 'A dual-hub enterprise bridging global sourcing with reliable regional execution across the Middle East.',
      quickLinks: 'Quick Links',
      contactTitle: 'Contact',
      copyright: '© {year} AIM TRADE. All rights reserved.',
    },
    // Locations
    locations: {
      saudiArabia: 'Saudi Arabia',
      uae: 'UAE',
      jordan: 'Jordan',
      kuwait: 'Kuwait',
      oman: 'Oman',
      iraq: 'Iraq',
      qatar: 'Qatar',
      palestine: 'Palestine',
      lebanon: 'Lebanon',
    },
  },
  ar: {
    // Header
    nav: {
      about: 'من نحن',
      services: 'خدماتنا',
      contact: 'تواصل معنا',
    },
    // Hero
    hero: {
      badge: 'Munich • Amman',
      title: 'ربط المعايير العالمية بالتميز الإقليمي',
      subtitle: 'نحن شركة استراتيجية متخصصة في إدارة المنتجات وتجارة الورق. نعمل كجسر يربط بين مصادر التوريد العالمية والتنفيذ الموثوق في منطقة الشرق الأوسط، لنقدم جودة يمكنك الوثوق بها من خلال مكتبينا في Munich و Amman.',
      ctaPrimary: 'طلب المواصفات الفنية',
      ctaSecondary: 'كن موزعاً معتمداً',
      countriesServed: 'دولة نخدمها',
      regionalPartners: 'شريك إقليمي',
    },
    // About
    about: {
      title: 'من نحن',
      whoWeAre: 'من نحن',
      whoWeAreText: 'تأسست الشركة على يد Ahmad Ismail Mousa، وتعمل كمنظومة دولية مزدوجة الانطلاق من خلال قاعدتينا الاستراتيجيتين في Germany و Jordan. نحن متخصصون في إدارة سلسلة القيمة الكاملة — بدءاً من التعاقد مع كبار المصنعين الدوليين وصولاً إلى ضمان التوصيل الإقليمي السلس.',
      mission: 'رسالتنا',
      missionText: 'تمكين نجاح شركائنا من خلال تقديم منتجات عالمية المستوى عبر شبكة شفافة وعالية الكفاءة، تجعل التوريد العالمي يبدو محلياً وسهلاً.',
      vision: 'رؤيتنا',
      visionText: 'أن نكون البوابة الأكثر موثوقية للعلامات التجارية العالمية الفاخرة في الشرق الأوسط، وإثراء الأسواق الإقليمية من خلال ضمان وصول كل شريك ومستهلك إلى الجودة العالمية دون مساومة.',
      coreValues: 'قيمنا الجوهرية',
      coreValueText: 'يرتكز عملنا على الانضباط التشغيلي والفهم العميق لمتطلبات السوق. نحن لا نكتفي بتوريد المنتجات فحسب، بل ندير النمو طويل الأمد للسوق من خلال علاقاتنا القوية والتزامنا بالموثوقية المستمرة.',
      // Why AIM TRADE
      whyTitle: 'لماذا نحن؟',
      why1Title: 'تواجد إقليمي ودولي',
      why1Text: 'نعمل من خلال مراكزنا الاستراتيجية في Munich و Amman، مما يمنحنا القدرة على الربط المباشر بين المصنعين العالميين والأسواق المحلية بكفاءة عالية.',
      why2Title: 'سلسلة توريد متكاملة',
      why2Text: 'نتولى إدارة العملية بالكامل؛ بدءاً من المصنع وصولاً إلى الرف. نحن نضمن جودة التوريد، والعمليات اللوجستية، والتوزيع النهائي بأعلى المعايير.',
      why3Title: 'فهم عميق للسوق',
      why3Text: 'نمتلك خبرة واسعة ورؤية تحليلية دقيقة لسوق الشرق الأوسط، مما يتيح لنا تحديد الفرص وضمان نجاح العلامات التجارية في بيئة تنافسية.',
    },
    // Services
    services: {
      title: 'خدماتنا المتخصصة',
      subtitle: 'نقدم التميز من خلال الشراكات الاستراتيجية والخبرة التشغيلية',
      tab1: 'تجارة الورق وخدمات سلاسل التوريد',
      tab2: 'إدارة العلامات التجارية وخدمات الوكالات',
      tab3: 'تطوير الأعمال وخدمات دخول الأسواق',
      partners: 'شركاؤنا:',
      // Paper Trading
      paperTitle: 'تجارة الورق وخدمات سلاسل التوريد',
      paperQuote: '«دقة في التوريد، موثوقية في التسليم»',
      paperText: 'نقدم حلولاً ورقية متكاملة لقادة الصناعة على المستويين الدولي والإقليمي. ومن خلال إدارة كافة العمليات بدءاً من المشتريات العالمية وصولاً إلى الخدمات اللوجستية النهائية، نضمن لشركائنا استلام مواد تطابق أدق المعايير الصناعية في الوقت المحدد دائماً.',
      // Brand Management
      brandTitle: 'إدارة العلامات التجارية وخدمات الوكالات',
      brandQuote: '«بناء علامات تجارية متميزة، وتوسيع الآفاق الإقليمية»',
      brandText: 'من خلال ذراع الوكالات لدينا، نمتلك حقوق تمثيل وتطوير علامات تجارية دولية فاخرة في منطقة الشرق الأوسط. نحن نعمل كحلقة وصل استراتيجية وصاحب الوكالة الإقليمي الذي يقوم بمنح حقوق التوزيع لموزعين حصريين في كل دولة، مما يضمن استمرارية العلامة التجارية والتوسع المدروس.',
      managedBrands: 'العلامات التجارية المدارة:',
      distributionPartners: 'شبكة التوزيع الإقليمية:',
      // Business Development
      businessTitle: 'تطوير الأعمال وخدمات دخول الأسواق',
      businessQuote: '«بوابتك الاستراتيجية للنمو العابر للحدود»',
      businessText: 'نستفيد من تواجدنا المزدوج في Europe و Middle East لتحديد فرص النمو الواعدة. يركز هذا القطاع على مساعدة الشركات في دخول الأسواق الإقليمية من خلال حلول مخصصة، واستشارات استراتيجية، وتوسيع نطاق الأعمال القائم على الشراكة.',
      businessPartnerName: 'شركة الأمير للطباعة',
      businessPartnerDesc: 'دعم الإنتاج الاستراتيجي والتنفيذ والتوسع في الأسواق الإقليمية',
      ourApproach: 'منهجيتنا:',
      approach1Title: 'استشارات استراتيجية',
      approach1Text: 'استراتيجيات دخول السوق المصممة خصيصاً',
      approach2Title: 'قائم على الشراكة',
      approach2Text: 'بناء علاقات طويلة الأمد',
      approach3Title: 'تواجد مزدوج',
      approach3Text: 'خبرة أوروبية وشرق أوسطية',
    },
    // Contact
    contact: {
      title: 'تواصل معنا',
      subtitle: 'تواصلوا مع فرقنا في Munich و Amman',
      regionalOffice: 'Regional Head Office – Amman',
      internationalOffice: 'International Office – Munich',
      address: 'Address',
      email: 'Email',
      phone: 'Phone',
      ammanLocation: 'Amman, Jordan',
      munichLocation: 'Munich, Germany',
      ctaTitle: 'مستعدون للشراكة معنا؟',
      ctaText: 'تواصلوا معنا لمناقشة كيفية دعم أهداف أعمالكم بمنتجات متميزة وتنفيذ موثوق',
      ctaEmail: 'راسلونا عبر البريد',
      ctaPhone: 'اتصلوا بنا',
    },
    // Footer
    footer: {
      description: 'منظومة دولية مزدوجة الانطلاق تربط التوريد العالمي بالتنفيذ الإقليمي الموثوق في منطقة الشرق الأوسط.',
      quickLinks: 'روابط سريعة',
      contactTitle: 'معلومات التواصل',
      copyright: '© {year} AIM TRADE. جميع الحقوق محفوظة.',
    },
    // Locations
    locations: {
      saudiArabia: 'المملكة العربية السعودية',
      uae: 'الإمارات العربية المتحدة',
      jordan: 'الأردن',
      kuwait: 'الكويت',
      oman: 'سلطنة عُمان',
      iraq: 'العراق',
      qatar: 'قطر',
      palestine: 'فلسطين',
      lebanon: 'لبنان',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('aimtrade-language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('aimtrade-language', language);
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ar' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
